import { useQueryClient } from "@tanstack/react-query";

import { HUB_CACHE_CHANNEL } from "@/lib/hubCacheChannels";
import { useHubCacheStream } from "@/lib/useHubCacheStream";

/** Invalidate ERP ingest run / control queries when hub-cache SSE fires (no refetchInterval). */
export function useErpIngestLiveQueries(enabled = true): void {
  const queryClient = useQueryClient();
  useHubCacheStream({
    channels: [HUB_CACHE_CHANNEL.erpIngestRuns, HUB_CACHE_CHANNEL.erpIngestControl],
    enabled,
    onEvent: (event) => {
      if (event.phase === "connected") {
        return;
      }
      if (event.channel === HUB_CACHE_CHANNEL.erpIngestRuns) {
        void queryClient.invalidateQueries({ queryKey: ["ingest-runs"] });
        void queryClient.invalidateQueries({ queryKey: ["ingest-events"] });
      }
      if (event.channel === HUB_CACHE_CHANNEL.erpIngestControl) {
        void queryClient.invalidateQueries({ queryKey: ["ingest-control"] });
      }
    },
  });
}
